//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContactForm from '../components/ContactForm'
import IntSlides from '../components/IntSlides'
export default {
  auth: false,
  components: {
    ContactForm,
    IntSlides
  },
  data () {
    return {
      topSlides: [
        {
          title: '',
          img: 'slider2.jpg'
        },
        {
          title: '',
          img: 'slider.jpg'
        }
      ]
    }
  },
  head: {
    title: 'Contáctanos',
    meta: [
      { hid: 'og:title', name: 'og:title', content: 'Contáctanos' },
      { hid: 'description', name: 'description', content: 'Contáctanos' }
    ]
  }
}
